import type {
  BaseGroupRequest,
  Group,
  GroupListResponse,
  GroupParams,
  UpdateGroupResponse,
  User,
  UserGroup,
  UserParams,
} from '@/domains/system-management/types/group';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

export const groupApi = {
  // Get group list
  getGroups: async (params: GroupParams): Promise<GroupListResponse[]> => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });
    const url = `${URLS.BACK_DSH}${APIS.initialAuthority(queryParams.toString())}`;
    return request.get(url);
  },

  // Get user list
  getUsers: async (params: UserParams): Promise<User[]> => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });
    const url = `${URLS.BACK_DSH}${APIS.initialAuthorityUser(queryParams.toString())}`;
    return request.get(url);
  },
  // Get group details
  getGroup: async (id: number | null): Promise<Group> => {
    if (id === null) throw new Error('getGroup: id is required');
    const url = `${URLS.BACK_DSH}${APIS.authorityUserInfo(id)}`;
    return request.get(url);
  },

  // Get user group
  getUserGroup: async (id: number | null): Promise<User[]> => {
    if (id === null) throw new Error('getUserGroup: id is required');
    const url = `${URLS.BACK_DSH}${APIS.authorityUserAssignInfo(id)}`;
    return request.get(url);
  },

  // Create group
  createGroup: async (data: BaseGroupRequest): Promise<{ group_code: number }> => {
    const url = `${URLS.BACK_DSH}${APIS.createAuthority}`;
    return request.post(url, data);
  },

  // Delete group
  deleteGroup: async (id: number): Promise<void> => {
    const url = `${URLS.BACK_DSH}${APIS.authorityUserInfo(id)}`;
    return request.delete(url, id);
  },

  // Update group
  updateGroup: async (id: number, data: Group): Promise<UpdateGroupResponse> => {
    const url = `${URLS.BACK_DSH}${APIS.authorityUserInfo(id)}`;
    return request.put(url, data);
  },

  // Update user group
  updateUserGroup: async (id: number, data: UserGroup): Promise<UpdateGroupResponse> => {
    const url = `${URLS.BACK_DSH}${APIS.authorityUserAssignInfo(id)}`;
    return request.put(url, data);
  },
};
